import React from "react";
import { Star, Quote } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

const AVATAR_COLORS = ["#00E5FF", "#80F2FF", "#FF5A36", "#FF8A70"];

function initials(name) {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("");
}

export default function Testimonials() {
  const { t } = useLang();
  const ts = t.testimonials;
  return (
    <section id="testimonials" className="relative py-24 md:py-36 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-cyan-brand mb-5">{ts.overline}</p>
          <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tighter text-white max-w-3xl leading-[0.95]">
            {ts.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-5">
          {ts.items.map((item, i) => (
            <Reveal key={i} delay={(i % 2) * 0.08}>
              <figure
                data-testid={`testimonial-${i}`}
                className="relative h-full rounded-3xl border border-white/10 bg-ink-surface/50 p-8 hover:border-white/20 transition-colors duration-300"
              >
                <Quote size={34} className="text-white/10 absolute top-6 right-6" strokeWidth={1.5} />
                <div className="flex gap-1 mb-5" aria-label={`${item.rating}/5`}>
                  {Array.from({ length: item.rating }).map((_, s) => (
                    <Star key={s} size={15} className="fill-cyan-brand text-cyan-brand" />
                  ))}
                </div>
                <blockquote className="text-white/85 text-lg font-light leading-relaxed">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-4">
                  <span
                    className="grid place-items-center w-12 h-12 rounded-full font-display font-bold text-ink-bg shrink-0"
                    style={{ background: AVATAR_COLORS[i % AVATAR_COLORS.length] }}
                  >
                    {initials(item.author)}
                  </span>
                  <span>
                    <span className="block text-white font-semibold">{item.author}</span>
                    <span className="block text-white/50 text-sm">
                      {item.role} · {item.restaurant}, {item.city}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
